import { Trophy } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function TopSellerBadge({
  className,
  size = "sm",
  compact = false,
}: {
  className?: string;
  size?: "sm" | "md";
  compact?: boolean;
}) {
  const h = size === "md" ? "h-6 px-2 text-[11px]" : "h-5 px-1.5 text-[10px]";
  const icon = size === "md" ? "h-3 w-3" : "h-2.5 w-2.5";
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            aria-label="Top Seller"
            className={cn(
              "inline-flex items-center gap-1 rounded-full font-medium uppercase tracking-wider",
              "bg-gradient-to-r from-amber-500/25 via-amber-400/20 to-yellow-500/25",
              "text-amber-100 border border-amber-400/40",
              "shadow-[0_0_15px_-6px_rgba(251,191,36,0.6)]",
              h,
              className,
            )}
          >
            <Trophy className={cn("text-amber-300", icon)} aria-hidden />
            {!compact && <span className="whitespace-nowrap">Top Seller</span>}
          </span>
        </TooltipTrigger>
        <TooltipContent>Recognised for strong marketplace performance.</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
